// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the Fouling Simulator Icon.
 * @param {IconProps} props - The IconProps for the FoulingSimulatorIcon component.
 * @returns {ReactElement} The FoulingSimulatorIcon component.
 */
export const FoulingSimulatorIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='30' height='33' viewBox='0 0 30 33' color={color} fill='transparent' {...rest} id='fouling-simulator'>
      <path
        d='M14.5757 1.07495V8.37991'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.5757 14.2197L28.0307 20.3335C28.0307 20.3335 28.741 27.9969 24.4688 31.0116H4.68257C0.400019 27.9969 1.12064 20.3335 1.12064 20.3335L14.5757 14.2197ZM14.5757 14.2197V22.0728'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.62085 18.7206V9.57096C4.62085 7.85277 5.97974 6.45081 7.66805 6.45081H21.4834C23.1614 6.45081 24.5203 7.84223 24.5203 9.56042V18.7522'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.71212 25.6146C5.97934 25.6146 6.19596 25.3928 6.19596 25.1192C6.19596 24.8456 5.97934 24.6238 5.71212 24.6238C5.4449 24.6238 5.22827 24.8456 5.22827 25.1192C5.22827 25.3928 5.4449 25.6146 5.71212 25.6146Z'
        fill='currentColor'
      />
      <path
        d='M22.5025 28.0707C23.4179 28.0707 24.16 27.3109 24.16 26.3736C24.16 25.4363 23.4179 24.6765 22.5025 24.6765C21.5871 24.6765 20.8451 25.4363 20.8451 26.3736C20.8451 27.3109 21.5871 28.0707 22.5025 28.0707Z'
        fill='currentColor'
      />
      <path
        d='M9.55192 23.0953C10.3252 23.0953 10.952 22.4535 10.952 21.6617C10.952 20.87 10.3252 20.2281 9.55192 20.2281C8.77869 20.2281 8.15186 20.87 8.15186 21.6617C8.15186 22.4535 8.77869 23.0953 9.55192 23.0953Z'
        fill='currentColor'
      />
      <path
        d='M7.59587 31.0749C8.3691 31.0749 8.99593 30.4331 8.99593 29.6413C8.99593 28.8496 8.3691 28.2078 7.59587 28.2078C6.82263 28.2078 6.1958 28.8496 6.1958 29.6413C6.1958 30.4331 6.82263 31.0749 7.59587 31.0749Z'
        fill='currentColor'
      />
      <path
        d='M22.5024 22.0622C22.7185 22.0622 22.8936 21.8829 22.8936 21.6617C22.8936 21.4404 22.7185 21.2611 22.5024 21.2611C22.2863 21.2611 22.1112 21.4404 22.1112 21.6617C22.1112 21.8829 22.2863 22.0622 22.5024 22.0622Z'
        fill='currentColor'
      />
      <path
        d='M18.8789 23.4853C19.0949 23.4853 19.2701 23.306 19.2701 23.0848C19.2701 22.8635 19.0949 22.6842 18.8789 22.6842C18.6628 22.6842 18.4877 22.8635 18.4877 23.0848C18.4877 23.306 18.6628 23.4853 18.8789 23.4853Z'
        fill='currentColor'
      />
      <path
        d='M14.5758 27.8071C14.843 27.8071 15.0596 27.5853 15.0596 27.3117C15.0596 27.0381 14.843 26.8163 14.5758 26.8163C14.3085 26.8163 14.0919 27.0381 14.0919 27.3117C14.0919 27.5853 14.3085 27.8071 14.5758 27.8071Z'
        fill='currentColor'
      />
    </Icon>
  );
};
